var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useCallback, useState, useMemo, useTransition } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Avatar, Typography, Card, CardContent, Grid, CircularProgress, Paper, Tooltip, Button, FormControlLabel, Checkbox, InputAdornment, TextField, IconButton, Menu, MenuItem, } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getAlertsDashboard, } from '../AlertsDashboard.action';
import { CLEAR_ALERTS_DASHBOARD_STATE } from './AlertsDashboard.types';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import OpacityIcon from '@mui/icons-material/Opacity';
import BedIcon from '@mui/icons-material/Bed';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import DevicesIcon from '@mui/icons-material/Devices';
import ClearIcon from '@mui/icons-material/Clear';
import ErrorIcon from '@mui/icons-material/Error';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import MonitorWeightIcon from '@mui/icons-material/MonitorWeight';
import HotelIcon from '@mui/icons-material/Hotel';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import clsx from 'clsx';
import WarningIcon from '@mui/icons-material/Warning';
import moment from 'moment';
import { hideApplicationLoader, showApplicationLoader, } from 'common/ApplicationLoader';
import { Roles } from 'globals/enums';
import { useAppSelector } from 'hooks/reduxHooks';
import SnoozeOutlinedIcon from '@mui/icons-material/SnoozeOutlined';
import { useNavigate } from 'react-router-dom';
import { DIALOG_TYPES, TABLE_CACHE_KEY } from 'globals/global.constants';
import { emptyPaginationData, openDialog } from 'store/commonReducer/common.action';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import AlertsDashboardPivot from './AlertsDashboardPivot';
import DevicesOtherIcon from '@mui/icons-material/DevicesOther';
import DeviceStatusDetailsDialog from 'common/Dialogs/DeviceStatusDetailsDialog';
var categoryColors = {
    red: '#dc2626', // Tailwind red-600
    yellow: '#facc15', // Tailwind yellow-400
    green: '#16a34a', // Tailwind green-600
    default: '#64748b', // Tailwind slate-500
};
var RISK_CATEGORY_VALUES = [
    'high',
    'moderate',
    'stable',
    'none',
];
var RISK_OPTIONS = [
    { label: 'High Risk', value: 'high' },
    { label: 'Moderate Risk', value: 'moderate' },
    { label: 'Stable', value: 'stable' },
    { label: 'Awaiting Activation', value: 'none' },
];
var RISK_THEME = {
    all: { bg: '#ffffff' },
    high: { bg: '#dc2626' },
    moderate: { bg: '#f59e0b' },
    stable: { bg: '#16a34a' },
    none: { bg: '#e5e7eb' },
};
var getCategoryColor = function (category) {
    return categoryColors[category] ||
        categoryColors.default;
};
export var useStyles = makeStyles()(function (theme) { return ({
    dashboardContainer: {
        padding: theme.spacing(3),
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
    },
    headerSection: {
        marginBottom: theme.spacing(4),
        padding: theme.spacing(4),
        backgroundColor: '#32602F',
        borderRadius: '16px',
        color: '#fff',
        boxShadow: '0 10px 25px rgba(102, 126, 234, 0.3)',
    },
    headerTitle: {
        fontSize: '28px',
        fontWeight: 700,
        marginBottom: theme.spacing(1),
        textAlign: 'center',
        backgroundColor: '#32602F',
    },
    headerSubtitle: {
        fontSize: '16px',
        opacity: 0.9,
        textAlign: 'center',
        fontWeight: 400,
    },
    statsCard: {
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderRadius: '16px',
        padding: theme.spacing(1.5),
        height: '100%',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
        },
    },
    alertCard: {
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderRadius: '12px',
        padding: theme.spacing(1.5),
        height: '100%',
        boxShadow: '0 6px 25px rgba(0, 0, 0, 0.08)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        paddingBottom: 0,
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
        },
    },
    highRiskBorder: {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '35px',
            background: '#dc2626', // Red for high risk
        },
    },
    moderateRiskBorder: {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '35px',
            background: '#f59e0b', // Yellow for moderate risk
        },
    },
    stableRiskBorder: {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '35px',
            background: '#16a34a', // Green for stable
        },
    },
    defaultRiskBorder: {
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '30px',
            background: 'linear-gradient(90deg, #b0b0b0, #707070)', // Default grey
        },
    },
    // Add BMI icon style
    bmiIcon: {
        backgroundColor: '#fef3c7',
        color: '#d97706',
    },
    // Add sleep efficiency and wakeup icons
    efficiencyIcon: {
        backgroundColor: '#dcfce7',
        color: '#16a34a',
    },
    wakeupIcon: {
        backgroundColor: '#fce7f3',
        color: '#be185d',
    },
    cardContent: {
        padding: theme.spacing(),
        '&:last-child': {
            padding: '8px !important',
            gap: theme.spacing(1),
            // marginBottom: theme.spacing(1),
        },
    },
    seniorSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    avatar: {
        width: 48,
        height: 48,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#fff',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
        marginLeft: '-14px',
    },
    seniorInfo: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        flexWrap: 'nowrap',
        // textOverflow: 'ellipsis',
    },
    seniorName: {
        fontSize: '0.9rem',
        fontWeight: 600,
        color: '#1e293b',
        whiteSpace: 'normal',
        marginBottom: 0,
        marginTop: '13px',
        wordBreak: 'break-word',
    },
    memberId: {
        fontSize: '0.8rem',
        color: '#64748b',
        fontWeight: 500,
        whiteSpace: 'nowrap',
    },
    metricsContainer: {
    // marginTop: theme.spacing(2),
    },
    metricRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(0.75),
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        marginBottom: theme.spacing(0.5),
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#e2e8f0',
            transform: 'scale(1.02)',
        },
    },
    metricInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    metricIcon: {
        padding: theme.spacing(0.5),
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    heartRateIcon: {
        // backgroundColor: '#fee2e2',
        color: '#dc2626',
    },
    weightIcon: {
        // backgroundColor: '#f3e8ff',
        color: '#7c3aed',
    },
    hydrationIcon: {
        backgroundColor: '#dbeafe',
        color: '#2563eb',
    },
    sleepIcon: {
        backgroundColor: '#dcfce7',
        color: '#16a34a',
    },
    metricValue: {
        fontWeight: 600,
        fontSize: '0.95rem',
    },
    metricLabel: {
        fontSize: '0.8rem',
        color: '#64748b',
        fontWeight: 500,
    },
    alertsSection: {
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2),
        borderTop: '1px solid #e2e8f0',
    },
    alertsHeader: {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: '#374151',
        marginBottom: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    alertChips: {
        display: 'flex',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
    },
    sosChip: {
        // backgroundColor: '#fee2e2',
        color: '#dc2626',
        fontWeight: 600,
        '& .MuiChip-icon': {
            color: '#dc2626',
        },
    },
    fallChip: {
        backgroundColor: '#fed7aa',
        color: '#ea580c',
        fontWeight: 600,
        '& .MuiChip-icon': {
            color: '#ea580c',
        },
    },
    noAlertsChip: {
        backgroundColor: '#dcfce7',
        color: '#16a34a',
        fontWeight: 600,
    },
    statusIndicator: {
        position: 'absolute',
        top: theme.spacing(1.5),
        right: theme.spacing(1.5),
        padding: theme.spacing(0.5),
    },
    onlineStatus: {
        color: '#16a34a',
    },
    offlineStatus: {
        color: '#dc2626',
    },
    loadingMore: {
        textAlign: 'center',
        margin: theme.spacing(4),
    },
    statsValue: {
        fontSize: '2rem',
        fontWeight: 700,
        background: 'linear-gradient(135deg, #32602F 0%, #32602F 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
    },
    noDataValue: {
        fontFamily: 'SFUIText',
        lineHeight: '1.5',
        letterSpacing: 0,
        fontSize: '0.7rem',
        fontWeight: 600,
        color: '#1e293b',
        whiteSpace: 'nowrap',
    },
    statsLabel: {
        fontSize: '0.8rem',
        color: '#64748b',
        fontWeight: 500,
        marginTop: theme.spacing(0.25),
    },
    deviceMetrics: {
        display: 'grid',
        // gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    emptyState: {
        textAlign: 'center',
        color: '#64748b',
        fontStyle: 'italic',
        padding: theme.spacing(2),
    },
    compactMetric: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        minWidth: 0,
    },
    metricText: {
        fontSize: '0.7rem',
        fontWeight: 600,
        color: '#1e293b',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    seniorInfoRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '8px',
    },
    memberInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minWidth: 0,
    },
    watchIconWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
    },
}); });
export var getRiskBorderClass = function (riskCategory, classes) {
    switch (riskCategory === null || riskCategory === void 0 ? void 0 : riskCategory.toLowerCase()) {
        case 'high':
            return classes.highRiskBorder;
        case 'moderate':
            return classes.moderateRiskBorder;
        case 'stable':
            return classes.stableRiskBorder;
        default:
            return classes.defaultRiskBorder;
    }
};
// Memoized SeniorCard Component
var SeniorCard = React.memo(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
    var senior = _a.senior, classes = _a.classes, handleAvatarClick = _a.handleAvatarClick;
    var _2 = useState(false), deviceDialogOpen = _2[0], setDeviceDialogOpen = _2[1];
    var _3 = useState(null), selectedDeviceStatus = _3[0], setSelectedDeviceStatus = _3[1];
    var _4 = useState(null), selectedDeviceMetrics = _4[0], setSelectedDeviceMetrics = _4[1];
    var handleDeviceIconClick = function (senior) {
        if (!senior.device_status || Object.keys(senior.device_status).length === 0)
            return;
        setSelectedDeviceStatus(senior.device_status);
        setSelectedDeviceMetrics(senior.devices || {});
        setDeviceDialogOpen(true);
    };
    var formatValue = function (value, unit) {
        if (value === null ||
            value === undefined ||
            value === 'N/A' ||
            value === '') {
            return '-';
        }
        return unit ? "".concat(value, " ").concat(unit) : value;
    };
    // ✅ Unified Device Status Icon Logic
    var getUnifiedDeviceStatus = function (deviceStatus, onClickHandler) {
        if (deviceStatus === void 0) { deviceStatus = {}; }
        if (!deviceStatus || Object.keys(deviceStatus).length === 0) {
            return (_jsx(Tooltip, { title: "No devices connected", children: _jsx(Box, { sx: {
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        backgroundColor: '#f1f5f9',
                        width: 24,
                        height: 24,
                        cursor: 'not-allowed',
                    }, children: _jsx(DevicesOtherIcon, { sx: { color: '#9ca3af', fontSize: 18 } }) }) }));
        }
        var statuses = Object.values(deviceStatus).map(function (d) {
            return String((d === null || d === void 0 ? void 0 : d.status) || "-").toLowerCase();
        });
        var onlineCount = statuses.filter(function (s) { return s === "online"; }).length;
        var offlineCount = statuses.filter(function (s) { return s === "offline"; }).length;
        var hyphenCount = statuses.filter(function (s) { return s === "-"; }).length;
        var color = "#9ca3af"; // gray default
        var tooltip = "No devices connected";
        // RULE 4 → All devices not connected
        if (hyphenCount === statuses.length) {
            color = "#9ca3af";
            tooltip = "No Device Connected";
        }
        // RULE 3 → All devices online
        else if (onlineCount === statuses.length) {
            color = "#16a34a";
            tooltip = "online";
        }
        // RULE 1 (existing) & RULE 5 (new) → Any offline + NO online → RED
        else if (offlineCount >= 1 && onlineCount === 0) {
            color = "#dc2626"; // red
            tooltip = "Atleast one device offline";
        }
        // RULE 1 → Online + offline → RED
        else if (onlineCount >= 1 && offlineCount >= 1) {
            color = "#dc2626";
            tooltip = "Atleast one device offline";
        }
        // RULE 2 → Online + not connected → GREEN
        else if (onlineCount >= 1 && offlineCount === 0) {
            color = "#16a34a"; // green
            tooltip = "At least one device online";
        }
        return (_jsx(Tooltip, { title: tooltip, children: _jsx(Box, { onClick: function (e) {
                    // ⛔ BLOCK CLICK if all devices are not connected
                    if (hyphenCount === statuses.length)
                        return;
                    e.stopPropagation();
                    onClickHandler();
                }, sx: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    width: 24,
                    height: 24,
                    backgroundColor: "".concat(color, "1A"),
                    cursor: hyphenCount === statuses.length ? 'not-allowed' : 'pointer',
                    transition: '0.3s ease',
                    '&:hover': {
                        transform: hyphenCount === statuses.length ? 'none' : 'scale(1.1)',
                    },
                    opacity: hyphenCount === statuses.length ? 0.6 : 1,
                }, children: _jsx(DevicesOtherIcon, { sx: { color: color, fontSize: 18 } }) }) }));
    };
    return (_jsxs(Card, { className: clsx(classes.alertCard, getRiskBorderClass(senior.risk_category, classes), { 'no-devices': !Object.keys(senior.device_status || {}).length }), onClick: function () { return handleAvatarClick(senior); }, sx: {
            cursor: 'pointer',
            opacity: 1,
        }, elevation: 0, children: [_jsxs(CardContent, { className: classes.cardContent, children: [_jsxs(Box, { className: classes.seniorSection, children: [_jsx(Avatar, { className: classes.avatar, src: ((_b = senior === null || senior === void 0 ? void 0 : senior.profile) === null || _b === void 0 ? void 0 : _b.image) || undefined, onClick: function () { return handleAvatarClick(senior); }, sx: { cursor: 'pointer' }, children: !((_c = senior === null || senior === void 0 ? void 0 : senior.profile) === null || _c === void 0 ? void 0 : _c.image) &&
                                    (function () {
                                        var _a;
                                        if (!(senior === null || senior === void 0 ? void 0 : senior.seniorName))
                                            return '?';
                                        var parts = senior.seniorName
                                            .trim()
                                            .split(' ')
                                            .filter(function (part) { return part && !part.startsWith('('); });
                                        if (parts.length === 0)
                                            return '?';
                                        if (parts.length === 1)
                                            return ((_a = parts[0][0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '?';
                                        var first = parts[0][0] || '';
                                        var last = parts[parts.length - 1][0] || '';
                                        return (first + last).toUpperCase() || '?';
                                    })() }), _jsxs(Box, { className: classes.seniorInfoRow, children: [_jsx(Typography, { component: "div", className: classes.seniorName, children: senior.seniorName || 'Unknown Senior' }), _jsxs(Box, { className: classes.watchIconWrapper, sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [senior.is_profile_paused && (_jsx(Tooltip, { title: "Profile Paused", children: _jsx(PauseCircleFilledIcon, { sx: { color: '#FFB74D', fontSize: 20 } }) })), getUnifiedDeviceStatus(senior.device_status, function () { return handleDeviceIconClick(senior); })] })] })] }), _jsx(Box, { className: classes.metricsContainer, children: _jsxs(Box, { sx: {
                                display: 'grid',
                                gridTemplateColumns: 'repeat(3, 1fr)',
                                mt: 1,
                            }, children: [_jsx(Box, { sx: {
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Heart Rate', children: _jsx(MonitorHeartIcon, { sx: {
                                                        fontSize: 14,
                                                        color: getCategoryColor((_e = (_d = senior.devices) === null || _d === void 0 ? void 0 : _d.watch) === null || _e === void 0 ? void 0 : _e.heart_category),
                                                    } }) }), _jsx(Typography, { component: "div", sx: {
                                                    fontSize: '0.75rem',
                                                    fontWeight: 600,
                                                    whiteSpace: 'nowrap',
                                                    color: '#1e293b',
                                                }, children: formatValue((_g = (_f = senior.devices) === null || _f === void 0 ? void 0 : _f.watch) === null || _g === void 0 ? void 0 : _g.heart_rate, ((_j = (_h = senior.devices) === null || _h === void 0 ? void 0 : _h.watch) === null || _j === void 0 ? void 0 : _j.heart_rate) ? 'bpm' : '') })] }) }), _jsx(Box, { sx: {
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Activity Score', children: _jsx(DirectionsWalkIcon, { sx: {
                                                        fontSize: 16,
                                                        color: getCategoryColor((_l = (_k = senior.devices) === null || _k === void 0 ? void 0 : _k.watch) === null || _l === void 0 ? void 0 : _l.activity_category),
                                                    } }) }), _jsx(Typography, { component: "div", sx: {
                                                    fontSize: '0.75rem',
                                                    fontWeight: 600,
                                                    whiteSpace: 'nowrap',
                                                    color: '#1e293b',
                                                }, children: formatValue((_o = (_m = senior.devices) === null || _m === void 0 ? void 0 : _m.watch) === null || _o === void 0 ? void 0 : _o.avg_activity_score) })] }) }), _jsx(Box, { sx: {
                                        borderRadius: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }, children: _jsx(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: (((_p = senior.alerts) === null || _p === void 0 ? void 0 : _p.sos) || 0) + (((_q = senior.alerts) === null || _q === void 0 ? void 0 : _q.falls) || 0) > 0 ? (_jsx(Tooltip, { title: "".concat(((_r = senior.alerts) === null || _r === void 0 ? void 0 : _r.sos) || 0, " SOS alerts, ").concat(((_s = senior.alerts) === null || _s === void 0 ? void 0 : _s.falls) || 0, " Fall alerts"), children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                }, children: [_jsx(WarningAmberIcon, { sx: { fontSize: 14, color: '#dc2626' } }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: "".concat(((_t = senior.alerts) === null || _t === void 0 ? void 0 : _t.sos) || 0, "/").concat(((_u = senior.alerts) === null || _u === void 0 ? void 0 : _u.falls) || 0) })] }) })) : (_jsx(Tooltip, { title: '0 SOS alerts, 0 Fall alerts', children: _jsxs(Box, { sx: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: 0.5,
                                                }, children: [_jsx(WarningIcon, { sx: { color: '#ef4444', fontSize: '14px' } }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: "0/0" })] }) })) }) }), ((_v = senior.devices) === null || _v === void 0 ? void 0 : _v.scale) ? (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Weight', children: _jsx(MonitorWeightIcon, { sx: {
                                                                fontSize: 16,
                                                                color: getCategoryColor(senior.devices.scale.weight_category),
                                                            } }) }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: formatValue(senior.devices.scale.avg_weight, senior.devices.scale.avg_weight ? 'lbs' : '') })] }) }), _jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Hydration', children: _jsx(OpacityIcon, { sx: {
                                                                fontSize: 14,
                                                                color: getCategoryColor(senior.devices.scale.hydration_category),
                                                            } }) }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: formatValue(senior.devices.scale.avg_hydration, senior.devices.scale.avg_hydration ? '%' : '') })] }) }), _jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            } })] })) : (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { minHeight: '50px' } }), _jsx(Box, { sx: { minHeight: '50px' } }), _jsx(Box, { sx: { minHeight: '50px' } })] })), ((_w = senior.devices) === null || _w === void 0 ? void 0 : _w.sleep_mat) ? (_jsxs(_Fragment, { children: [_jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Sleep Score', children: _jsx(HotelIcon, { sx: {
                                                                fontSize: 14,
                                                                color: getCategoryColor(senior.devices.sleep_mat.sleep_category),
                                                            } }) }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: formatValue(senior.devices.sleep_mat.avg_sleep_score) })] }) }), _jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: "Interruptions: ".concat((_x = senior.devices.sleep_mat.interruptions) !== null && _x !== void 0 ? _x : '-'), children: _jsx(SnoozeOutlinedIcon, { sx: {
                                                                fontSize: 16,
                                                                color: getCategoryColor(senior.devices.sleep_mat.sleep_category),
                                                            } }) }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: formatValue((_y = senior.devices.sleep_mat.interruptions) !== null && _y !== void 0 ? _y : '-') })] }) }), _jsx(Box, { sx: {
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Tooltip, { title: 'Sleep Duration', children: _jsx(BedIcon, { sx: { fontSize: 14, color: '#4f46e5' } }) }), _jsx(Typography, { component: "div", sx: {
                                                            fontSize: '0.75rem',
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                            color: '#1e293b',
                                                        }, children: (function () {
                                                            var totalSeconds = senior.devices.sleep_mat.avg_total_sleep_time || 0;
                                                            var hours = Math.floor(totalSeconds / 3600);
                                                            var minutes = Math.floor((totalSeconds % 3600) / 60);
                                                            return "".concat(hours, "h ").concat(minutes, "m");
                                                        })() })] }) })] })) : (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { minHeight: '50px' } }), _jsx(Box, { sx: { minHeight: '50px' } }), _jsx(Box, { sx: { minHeight: '50px' } })] })), !((_z = senior.devices) === null || _z === void 0 ? void 0 : _z.watch) &&
                                    !((_0 = senior.devices) === null || _0 === void 0 ? void 0 : _0.scale) &&
                                    !((_1 = senior.devices) === null || _1 === void 0 ? void 0 : _1.sleep_mat) && (_jsxs(Box, { sx: {
                                        gridColumn: 'span 3',
                                        backgroundColor: '#f8fafc',
                                        borderRadius: '12px',
                                        padding: 3,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        minHeight: '120px',
                                    }, children: [_jsx(DevicesIcon, { sx: { fontSize: 36, opacity: 0.3, mb: 1 } }), _jsx(Typography, { component: "div", sx: { fontSize: '0.8rem', color: '#64748b' }, children: "No devices assigned" })] }))] }) })] }), deviceDialogOpen && (_jsx(DeviceStatusDetailsDialog, { open: deviceDialogOpen, onClose: function () { return setDeviceDialogOpen(false); }, deviceStatus: selectedDeviceStatus, deviceMetrics: selectedDeviceMetrics }))] }));
});
SeniorCard.displayName = 'SeniorCard';
var AlertsDashboard = function () {
    var classes = useStyles().classes;
    var dispatch = useDispatch();
    var userRole = useSelector(function (state) { return state.auth.roleConfig.role; });
    var _a = useState(false), allSeniorsChecked = _a[0], setAllSeniorsChecked = _a[1];
    var _b = useState(''), searchQuery = _b[0], setSearchQuery = _b[1];
    var _c = useState(''), debouncedSearchQuery = _c[0], setDebouncedSearchQuery = _c[1];
    var _d = useState(false), disableAllSeniorsCheckbox = _d[0], setDisableAllSeniorsCheckbox = _d[1];
    var _e = useState(false), isStorageLoaded = _e[0], setIsStorageLoaded = _e[1];
    var _f = useTransition(), isPending = _f[0], startTransition = _f[1];
    var navigate = useNavigate();
    var initialLoadRef = useRef(true);
    var facilityDetails = useAppSelector(function (state) { return state.auth.facilityDetails; });
    var handleAvatarClick = useCallback(function (senior) {
        var _a, _b;
        if (!senior)
            return;
        var seniorId = senior === null || senior === void 0 ? void 0 : senior.seniorId;
        var accountId = (_a = senior === null || senior === void 0 ? void 0 : senior.profile) === null || _a === void 0 ? void 0 : _a.account_id;
        var seniorTimezone = (((_b = senior === null || senior === void 0 ? void 0 : senior.location) === null || _b === void 0 ? void 0 : _b.timezone) || 'America/New_York').replaceAll('/', '-');
        if (!seniorId || !accountId)
            return;
        dispatch(emptyPaginationData(TABLE_CACHE_KEY.CALL_LOGS));
        if (userRole === Roles.FACILITY_AGENT) {
            var facilityId_1 = facilityDetails === null || facilityDetails === void 0 ? void 0 : facilityDetails.facility_id;
            var facilityType = facilityDetails === null || facilityDetails === void 0 ? void 0 : facilityDetails.facility_type;
            sessionStorage.setItem('currentFacilityType', facilityType);
            navigate("/facility-management/".concat(facilityId_1, "/residents/").concat(seniorId, "/").concat(accountId, "/").concat(seniorTimezone));
        }
        else {
            navigate("/senior/".concat(seniorId, "/").concat(accountId, "/").concat(seniorTimezone, "/dashboard"));
        }
    }, [navigate, userRole, facilityDetails, dispatch]);
    var _g = useState([]), riskFilter = _g[0], setRiskFilter = _g[1];
    var _h = useState([]), displayRiskFilter = _h[0], setDisplayRiskFilter = _h[1];
    var _j = useState(false), isRiskAllDeselected = _j[0], setIsRiskAllDeselected = _j[1];
    var _k = useState(false), isDisplayRiskAllDeselected = _k[0], setIsDisplayRiskAllDeselected = _k[1];
    var _l = useState(null), riskFilterAnchor = _l[0], setRiskFilterAnchor = _l[1];
    var isRiskAllSelected = !isDisplayRiskAllDeselected && displayRiskFilter.length === 0;
    var hasRiskFilter = displayRiskFilter.length > 0 || isDisplayRiskAllDeselected;
    var riskTheme = displayRiskFilter.length === 1
        ? RISK_THEME[displayRiskFilter[0]]
        : RISK_THEME.all;
    useEffect(function () {
        var saved = sessionStorage.getItem('alertsDashboard_risk');
        if (saved &&
            ['all', 'high', 'moderate', 'stable', 'none'].includes(saved)) {
            var selectedRisks = saved === 'all' ? [] : [saved];
            setRiskFilter(selectedRisks);
            setDisplayRiskFilter(selectedRisks);
        }
        else if (saved === 'none-selected') {
            setIsRiskAllDeselected(true);
            setIsDisplayRiskAllDeselected(true);
        }
        else if (saved) {
            var selectedRisks = saved
                .split(',')
                .filter(function (value) {
                return RISK_CATEGORY_VALUES.includes(value);
            });
            if (selectedRisks.length) {
                var normalizedRisks = selectedRisks.length === RISK_CATEGORY_VALUES.length
                    ? []
                    : selectedRisks;
                setRiskFilter(normalizedRisks);
                setDisplayRiskFilter(normalizedRisks);
            }
        }
        return function () {
            dispatch({ type: CLEAR_ALERTS_DASHBOARD_STATE });
        };
    }, []);
    // Handle checkbox toggle
    var handleAllSeniorsChange = useCallback(function (event) {
        var checked = event.target.checked;
        setAllSeniorsChecked(checked);
        sessionStorage.setItem('alertsDashboard_allSeniorsChecked', String(checked));
        dispatch({ type: CLEAR_ALERTS_DASHBOARD_STATE });
    }, [dispatch]);
    var _m = useState(function () {
        var savedTimeFrame = sessionStorage.getItem('alertsDashboard_timeFrame');
        return savedTimeFrame || 'day';
    }), timeFrame = _m[0], setTimeFrame = _m[1];
    var _o = useState(false), timeFrameLoading = _o[0], setTimeFrameLoading = _o[1];
    var bottomRef = useRef(null);
    var _p = useAppSelector(function (state) { return state.alertsDashboard; }), seniorsData = _p.seniorsData, loading = _p.loading, 
    // currentPage,
    // totalRows,
    // devicesData,
    // sosFallsData,
    error = _p.error, lastEvaluatedKey = _p.lastEvaluatedKey;
    var filteredSeniorsData = useMemo(function () {
        if (!seniorsData)
            return [];
        if (isRiskAllDeselected) {
            return [];
        }
        if (riskFilter.length === 0) {
            return seniorsData;
        }
        return seniorsData.filter(function (senior) {
            return riskFilter.includes(senior.risk_category === null ? 'none' : senior.risk_category);
        });
    }, [seniorsData, riskFilter, isRiskAllDeselected]);
    var applyRiskFilter = function (selectedValues, allDeselected) {
        setDisplayRiskFilter(selectedValues);
        setIsDisplayRiskAllDeselected(allDeselected);
        sessionStorage.setItem('alertsDashboard_risk', allDeselected
            ? 'none-selected'
            : selectedValues.length
                ? selectedValues.join(',')
                : 'all');
        startTransition(function () {
            setRiskFilter(selectedValues);
            setIsRiskAllDeselected(allDeselected);
        });
    };
    var handleRiskFilterChange = function (value) {
        if (!value) {
            applyRiskFilter([], isRiskAllSelected);
            return;
        }
        var nextValues = isDisplayRiskAllDeselected
            ? [value]
            : isRiskAllSelected
                ? RISK_CATEGORY_VALUES.filter(function (category) { return category !== value; })
                : displayRiskFilter.includes(value)
                    ? displayRiskFilter.filter(function (category) { return category !== value; })
                    : __spreadArray(__spreadArray([], displayRiskFilter, true), [value], false);
        if (!nextValues.length) {
            applyRiskFilter([], true);
            return;
        }
        applyRiskFilter(nextValues.length === RISK_CATEGORY_VALUES.length ? [] : nextValues, false);
    };
    var handleResetRiskFilter = function () {
        applyRiskFilter([], false);
    };
    var handleTimeFrameChange = useCallback(function (period) {
        setTimeFrame(period);
        setTimeFrameLoading(true);
        sessionStorage.setItem('alertsDashboard_timeFrame', period);
    }, []);
    var _q = useState('card'), viewMode = _q[0], setViewMode = _q[1];
    var _r = useState(0), forceRenderKey = _r[0], setForceRenderKey = _r[1];
    var handleViewModeChange = function (_, newView) {
        if (!newView)
            return;
        setViewMode(newView);
        // ✅ Force re-render to ensure smooth toggle
        setForceRenderKey(function (prev) { return prev + 1; });
    };
    var startAndEndDates = useMemo(function () {
        var endTime = moment().unix() * 1000000000;
        var startTime = timeFrame === 'day'
            ? moment().startOf('day').unix() * 1000000000
            : timeFrame === 'week'
                ? moment().startOf('week').unix() * 1000000000
                : moment().startOf('month').unix() * 1000000000;
        return { start_time: startTime, end_time: endTime };
    }, [timeFrame]);
    useEffect(function () {
        var timer = setTimeout(function () {
            if (searchQuery.trim().length === 0 || searchQuery.trim().length >= 3) {
                setDebouncedSearchQuery(searchQuery);
            }
        }, 500);
        return function () { return clearTimeout(timer); };
    }, [searchQuery]);
    var searchParams = useMemo(function () {
        var baseParams = {
            start_time: timeFrame === 'day'
                ? moment().startOf('day').unix() * 1000000000
                : timeFrame === 'week'
                    ? moment().startOf('week').unix() * 1000000000
                    : moment().startOf('month').unix() * 1000000000,
            end_time: moment().unix() * 1000000000,
        };
        return debouncedSearchQuery.trim()
            ? __assign(__assign({}, baseParams), { search_query: debouncedSearchQuery.trim() }) : baseParams;
    }, [timeFrame, debouncedSearchQuery]);
    // Add this ref to track if we had a search before
    var prevSearchRef = useRef({ searchQuery: '' });
    var facilityId = facilityDetails === null || facilityDetails === void 0 ? void 0 : facilityDetails.facility_id;
    var prevFacilityIdRef = useRef(facilityId);
    useEffect(function () {
        var savedSearchQuery = sessionStorage.getItem('alertsDashboard_searchQuery') ||
            sessionStorage.getItem('alertsDashboard_nameSearch') ||
            sessionStorage.getItem('alertsDashboard_memberIdSearch') ||
            '';
        var savedAllSeniorsChecked = sessionStorage.getItem('alertsDashboard_allSeniorsChecked');
        setSearchQuery(savedSearchQuery);
        setAllSeniorsChecked(savedAllSeniorsChecked === 'true');
        setIsStorageLoaded(true);
    }, []);
    useEffect(function () {
        if (!isStorageLoaded)
            return;
        var hadSearch = !!prevSearchRef.current.searchQuery;
        var hasNoSearchNow = !searchQuery;
        var savedAllSeniorsChecked = sessionStorage.getItem('alertsDashboard_allSeniorsChecked') === 'true';
        var hasSavedFilters = sessionStorage.getItem('alertsDashboard_searchQuery') ||
            sessionStorage.getItem('alertsDashboard_nameSearch') ||
            sessionStorage.getItem('alertsDashboard_memberIdSearch');
        if (initialLoadRef.current) {
            initialLoadRef.current = false;
            if (hasSavedFilters) {
                // restore saved filters
                setDebouncedSearchQuery(searchQuery);
                prevSearchRef.current = { searchQuery: searchQuery };
            }
            else if (savedAllSeniorsChecked) {
                setAllSeniorsChecked(true);
                (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, true, timeFrame))];
                            case 1:
                                result = _a.sent();
                                if (result === null || result === void 0 ? void 0 : result.forcedAllSeniors) {
                                    setAllSeniorsChecked(true);
                                }
                                dispatch(hideApplicationLoader());
                                setTimeFrameLoading(false);
                                return [2 /*return*/];
                        }
                    });
                }); })();
                prevSearchRef.current = { searchQuery: searchQuery };
            }
            else {
                (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, false, timeFrame))];
                            case 1:
                                result = _a.sent();
                                if (!((result === null || result === void 0 ? void 0 : result.forcedAllSeniors) && !allSeniorsChecked)) return [3 /*break*/, 3];
                                setAllSeniorsChecked(true);
                                setDisableAllSeniorsCheckbox(true);
                                return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, true, timeFrame))];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3:
                                dispatch(hideApplicationLoader());
                                setTimeFrameLoading(false);
                                return [2 /*return*/];
                        }
                    });
                }); })();
                prevSearchRef.current = { searchQuery: searchQuery };
            }
        }
        else if (hadSearch && hasNoSearchNow) {
            if (allSeniorsChecked)
                setAllSeniorsChecked(false);
            prevSearchRef.current = { searchQuery: searchQuery };
            dispatch(getAlertsDashboard(searchParams, false, timeFrame)).finally(function () {
                dispatch(hideApplicationLoader());
                setTimeFrameLoading(false);
            });
        }
        else {
            prevSearchRef.current = { searchQuery: searchQuery };
            (function () { return __awaiter(void 0, void 0, void 0, function () {
                var result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, allSeniorsChecked, timeFrame))];
                        case 1:
                            result = _a.sent();
                            if (!((result === null || result === void 0 ? void 0 : result.forcedAllSeniors) && !allSeniorsChecked)) return [3 /*break*/, 3];
                            setAllSeniorsChecked(true);
                            return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, true, timeFrame))];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            dispatch(hideApplicationLoader());
                            setTimeFrameLoading(false);
                            return [2 /*return*/];
                    }
                });
            }); })();
        }
        return function () {
            dispatch({ type: CLEAR_ALERTS_DASHBOARD_STATE });
        };
    }, [dispatch, searchParams, allSeniorsChecked, isStorageLoaded]);
    useEffect(function () {
        if (prevFacilityIdRef.current === facilityId)
            return;
        prevFacilityIdRef.current = facilityId;
        if (!isStorageLoaded)
            return;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dispatch(showApplicationLoader());
                        return [4 /*yield*/, dispatch(getAlertsDashboard(searchParams, allSeniorsChecked, timeFrame))];
                    case 1:
                        result = _a.sent();
                        if ((result === null || result === void 0 ? void 0 : result.forcedAllSeniors) && !allSeniorsChecked) {
                            setAllSeniorsChecked(true);
                            setDisableAllSeniorsCheckbox(true);
                        }
                        dispatch(hideApplicationLoader());
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [facilityId, isStorageLoaded, dispatch, searchParams, allSeniorsChecked, timeFrame]);
    var handleRefresh = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var timezone, startTime, endTime, updatedParams, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showApplicationLoader());
                    timezone = 'Asia/Calcutta';
                    startTime = timeFrame === 'day'
                        ? moment().startOf('day').unix() * 1000000000
                        : timeFrame === 'week'
                            ? moment().startOf('week').unix() * 1000000000
                            : moment().startOf('month').unix() * 1000000000;
                    endTime = moment().unix() * 1000000000;
                    updatedParams = __assign(__assign({}, searchParams), { start_time: startTime, end_time: endTime, timezone: timezone, ascending: true });
                    return [4 /*yield*/, dispatch(getAlertsDashboard(updatedParams, allSeniorsChecked, timeFrame))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.forcedAllSeniors) && !allSeniorsChecked) {
                        setAllSeniorsChecked(true);
                        setDisableAllSeniorsCheckbox(true);
                    }
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/];
            }
        });
    }); }, [dispatch, searchParams, allSeniorsChecked, timeFrame]);
    useEffect(function () {
        var interval = setInterval(function () {
            var refreshDialogProps = {
                successButtonText: 'Continue',
                type: DIALOG_TYPES.REFRESH,
                isFailButton: true,
                data: {},
                onSuccessButton: function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, handleRefresh()];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); },
            };
            dispatch(openDialog(refreshDialogProps));
        }, 15 * 60 * 1000);
        return function () { return clearInterval(interval); };
    }, [dispatch, handleRefresh]);
    var loadMore = useCallback(function () {
        if (lastEvaluatedKey) {
            dispatch(getAlertsDashboard(__assign({ last_evaluated_key: lastEvaluatedKey }, startAndEndDates), allSeniorsChecked, timeFrame));
        }
    }, [dispatch, lastEvaluatedKey, startAndEndDates, allSeniorsChecked, timeFrame]);
    useEffect(function () {
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                loadMore();
            }
        }, { threshold: 1.0 });
        if (bottomRef.current)
            observer.observe(bottomRef.current);
        return function () {
            if (bottomRef.current)
                observer.unobserve(bottomRef.current);
        };
    }, [loadMore, loading]);
    var handleSearchChange = useCallback(function (e) {
        var value = e.target.value;
        if (/^[a-zA-Z0-9\s!@#$%^&*()_\-+=\[\]{}|;:'",.<>/?\\]*$/.test(value)) {
            setSearchQuery(value);
            sessionStorage.setItem('alertsDashboard_searchQuery', value || '');
        }
    }, []);
    var formatValue = function (value, unit) {
        if (value === null ||
            value === undefined ||
            value === 'N/A' ||
            value === '') {
            return '-';
        }
        return unit ? "".concat(value, " ").concat(unit) : value;
    };
    if (error) {
        return (_jsxs(Box, { textAlign: 'center', color: 'red', p: 4, children: [_jsx(ErrorIcon, { sx: { fontSize: 64, mb: 2 } }), _jsx(Typography, { component: "div", variant: 'h5', gutterBottom: true, children: "Error Loading Dashboard" }), _jsx(Typography, { component: "div", children: error })] }));
    }
    return (_jsxs(Box, { className: classes.dashboardContainer, children: [_jsxs(Paper, { className: classes.headerSection, elevation: 0, children: [_jsx(Typography, { component: 'h1', className: classes.headerTitle, children: "ClearWellness Care Dashboard" }), _jsx(Typography, { component: "div", className: classes.headerSubtitle, children: "Real-time health monitoring and alert management" })] }), (userRole === Roles.Admin ||
                userRole === Roles.CareAgent ||
                userRole === Roles.FACILITY_AGENT ||
                userRole === Roles.Admin_WellnessServices) && (_jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    mb: 3,
                }, children: _jsxs(Box, { sx: {
                        display: 'inline-grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))',
                        gap: '8px',
                        width: {
                            xs: '100%',
                            md: '70%',
                        },
                    }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Button, { variant: "contained", color: "primary", endIcon: _jsx(KeyboardArrowDownIcon, {}), onClick: function (event) { return setRiskFilterAnchor(event.currentTarget); }, sx: {
                                        backgroundColor: riskTheme.bg,
                                        color: '#000000',
                                        borderRadius: '20px',
                                        height: '40px',
                                        whiteSpace: 'nowrap',
                                        '&:hover': { backgroundColor: riskTheme.bg },
                                    }, "aria-haspopup": "true", "aria-expanded": Boolean(riskFilterAnchor), "data-testid": "riskFilterMenu", children: "Select Filters" }), _jsx(Button, { variant: "outlined", onClick: handleResetRiskFilter, disabled: !hasRiskFilter, sx: { height: '40px', whiteSpace: 'nowrap' }, "data-testid": "riskFilterReset", children: "Reset Filters" }), _jsxs(Menu, { anchorEl: riskFilterAnchor, open: Boolean(riskFilterAnchor), onClose: function () { return setRiskFilterAnchor(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, MenuListProps: { disablePadding: true }, "data-testid": "riskFilterDropdown", children: [_jsxs(MenuItem, { dense: true, onClick: function () { return handleRiskFilterChange(); }, "data-testid": "riskFilterAll", children: [_jsx(Checkbox, { checked: isRiskAllSelected, tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), "All Risks"] }), RISK_OPTIONS.map(function (option) { return (_jsxs(MenuItem, { dense: true, onClick: function () { return handleRiskFilterChange(option.value); }, "data-testid": "riskFilter-".concat(option.value), children: [_jsx(Checkbox, { checked: !isDisplayRiskAllDeselected &&
                                                        (displayRiskFilter.length === 0 ||
                                                            displayRiskFilter.includes(option.value)), tabIndex: -1, disableRipple: true, sx: { pointerEvents: 'none' } }), option.label] }, option.value)); })] })] }), _jsx(TextField, { placeholder: 'Search by Member ID or Name', value: searchQuery || '', onChange: handleSearchChange, disabled: loading, type: 'text', size: 'small', sx: {
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#e2e8f0',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#cbd5e1',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#32602F',
                                    },
                                },
                            }, InputProps: {
                                startAdornment: (_jsx(InputAdornment, { position: 'start', children: _jsx(SearchIcon, { sx: { color: '#64748b' } }) })),
                                endAdornment: searchQuery && (_jsx(InputAdornment, { position: 'end', children: _jsx(IconButton, { size: 'small', disabled: loading, onClick: function () {
                                            setSearchQuery('');
                                            sessionStorage.setItem('alertsDashboard_searchQuery', '');
                                        }, edge: 'end', children: _jsx(ClearIcon, { sx: { color: '#64748b' } }) }) })),
                            } }), _jsx(Button, { variant: 'contained', onClick: handleRefresh, sx: {
                                marginLeft: 1,
                                backgroundColor: '#32602F',
                                color: '#fff',
                                fontWeight: 600,
                                textTransform: 'none',
                                padding: '6px 16px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                '&:hover': {
                                    backgroundColor: '#244022',
                                },
                                '&:disabled': {
                                    backgroundColor: '#bfc4d6',
                                },
                            }, children: loading ? "Refreshing..." : "Refresh" })] }) })), _jsxs(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    flexWrap: 'wrap',
                    gap: '8px',
                    py: 3,
                    mb: 2,
                }, children: [_jsx(Box, { sx: {
                            position: 'relative',
                            display: 'inline-flex',
                            backgroundColor: '#e5e7eb',
                            borderRadius: '50px',
                            padding: '4px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        }, children: ['day', 'week', 'month'].map(function (period) { return (_jsx(Button, { onClick: function () { return handleTimeFrameChange(period); }, variant: 'text', sx: __assign({ position: 'relative', px: 3, py: 1, fontSize: '0.875rem', fontWeight: 600, borderRadius: '50px', minWidth: '70px', transition: 'all 0.3s ease-in-out', zIndex: timeFrame === period ? 10 : 1 }, (timeFrame === period
                                ? {
                                    backgroundColor: '#ffffff',
                                    color: '#244022',
                                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                                    transform: 'scale(1.05)',
                                }
                                : {
                                    color: '#6b7280',
                                    '&:hover': {
                                        color: '#374151',
                                        backgroundColor: 'transparent',
                                    },
                                })), children: period.toUpperCase() }, period)); }) }), _jsxs(ToggleButtonGroup, { value: viewMode, exclusive: true, onChange: handleViewModeChange, sx: {
                            backgroundColor: '#e5e7eb',
                            borderRadius: '50px',
                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                            '& .MuiToggleButton-root': {
                                border: 'none',
                                textTransform: 'none',
                                fontWeight: 600,
                                color: '#6b7280',
                                '&.Mui-selected': {
                                    backgroundColor: '#ffffff',
                                    color: '#244022',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                },
                            },
                        }, children: [_jsx(ToggleButton, { value: "card", children: "Card View" }), _jsx(ToggleButton, { value: "pivot", children: "Pivot View" })] }), userRole === Roles.CareAgent && (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: allSeniorsChecked, onChange: handleAllSeniorsChange, color: 'primary', disabled: disableAllSeniorsCheckbox }), label: 'All Seniors' }))] }), isPending ? (_jsxs(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '300px',
                    backgroundColor: '#fff',
                    borderRadius: '16px',
                    padding: 4,
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                }, children: [_jsx(CircularProgress, { size: 40, sx: { color: '#32602F' } }), _jsx(Typography, { component: 'div', sx: { mt: 2, color: '#64748b' }, children: "Updating results..." })] })) : viewMode === 'card' ? (_jsxs(Grid, { container: true, spacing: 3, justifyContent: "center", children: [!loading && filteredSeniorsData.length === 0 && (_jsx(Box, { sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minHeight: '200px',
                            backgroundColor: '#fff',
                            borderRadius: '16px',
                            padding: 4,
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        }, children: _jsx(Typography, { sx: {
                                fontSize: '1.25rem',
                                fontWeight: 600,
                                color: '#475569',
                                mb: 1,
                            }, children: "No Records Found" }) })), filteredSeniorsData === null || filteredSeniorsData === void 0 ? void 0 : filteredSeniorsData.map(function (senior) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, lg: 3, children: _jsx(SeniorCard, { senior: senior, classes: classes, handleAvatarClick: handleAvatarClick }) }, senior.seniorId)); })] }, "card-".concat(forceRenderKey))) : (_jsx(AlertsDashboardPivot, { seniorsData: filteredSeniorsData, 
                // seniorsData={seniorsData}
                loading: loading, lastEvaluatedKey: lastEvaluatedKey, allSeniorsChecked: allSeniorsChecked, searchParams: searchParams, handleAvatarClick: handleAvatarClick }, "pivot-".concat(forceRenderKey))), _jsx("div", { ref: bottomRef, className: classes.loadingMore, children: (loading || timeFrameLoading) && viewMode === 'card' && !isPending && (_jsxs(Box, { children: [_jsx(CircularProgress, { size: 40, sx: { color: '#32602F' } }), _jsx(Typography, { component: 'div', sx: { mt: 2, color: '#64748b' }, children: "Loading seniors..." })] })) })] }));
};
export default AlertsDashboard;
